export default __webpack_public_path__ + "static/media/stock_reports.a9adb7d7.svg";